import * as React from 'react';
import { navigate } from 'gatsby';
import * as Core from 'components/core';
type Props = {
  selected: boolean;
  result: {
    path: string;
    content: string;
    title: string;
  };
  rawQuery: string;
  onSelectResult: () => void;
};
const contextWindowSize = 80;
export default (props: Props) => {
  const { rawQuery, selected, result, onSelectResult } = props;
  const select = () => {
    navigate(result.path);
    onSelectResult();
  };
  const query = rawQuery.toLowerCase();
  const title = result.title.toLowerCase();
  const content = result.content.toLowerCase();
  const titleMatches = title.includes(query);
  const titleMatchStart = titleMatches ? title.indexOf(query) : 0;
  const contentMatches = content.includes(query);
  const contentMatchStart = contentMatches ? content.indexOf(query) : 0;
  const contextStart = Math.max(0, contentMatchStart - contextWindowSize);
  const contextEnd = Math.min(
    result.content.length,
    contentMatchStart + query.length + contextWindowSize,
  );
  console.log({
    title,
    contextWindowSize,
    contentMatchStart,
    contextStart,
    contextEnd,
    queryLength: query.length,
  });
  return (
    <div
      className={`docs-SearchResults-result ${selected ? 'is-selected' : ''}`}
      onClick={select}
    >
      <Core.Link to={result.path}>
        {titleMatches ? (
          <>
            {result.title.slice(0, titleMatchStart)}
            <strong>
              {result.title.slice(
                titleMatchStart,
                titleMatchStart + query.length,
              )}
            </strong>
            {result.title.slice(
              titleMatchStart + query.length,
              result.title.length,
            )}
          </>
        ) : (
          result.title
        )}
      </Core.Link>
      {contentMatches && (
        <div className="docs-SearchResults-result-matchingContent">
          {contextStart !== 0 && <>&hellip;</>}
          {result.content.slice(contextStart, contentMatchStart)}
          <strong>
            {result.content.slice(
              contentMatchStart,
              contentMatchStart + query.length,
            )}
          </strong>
          {result.content.slice(contentMatchStart + query.length, contextEnd)}
          {contextEnd !== result.content.length && <>&hellip;</>}
        </div>
      )}
    </div>
  );
};
